import { render, staticRenderFns } from "./NewNoPlayLabel.vue?vue&type=template&id=d65e743a&scoped=true&"
import script from "./NewNoPlayLabel.vue?vue&type=script&lang=js&"
export * from "./NewNoPlayLabel.vue?vue&type=script&lang=js&"
import style0 from "./NewNoPlayLabel.vue?vue&type=style&index=0&id=d65e743a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65e743a",
  null
  
)

export default component.exports